import * as orderApi from '../../api/orderApi'
import Vue from 'vue';
import layer from 'vue-layer';

let $layer = layer(Vue)

const state = {
    List: [],
    HasMore: true,
    PageIndex: 1,
    ErrMsg: '',
    ReceivedStatus: false,
    Refresh: false,
    TabIndex: 30,
    SearchText: ''
}

const getters = {

}

const actions = {
    async GetOrderList ({ commit }, filter) {
        let response = await orderApi.GetOrderList(filter)
        if (response.Status) {
            if(response.PageNo >= response.PageCount){
                commit('setHasMore', false)
            }
            else{
                commit('setHasMore', true)
            }
            if(filter.PageNo === 1){
                commit('setList', response.Rows);
            }else{
                commit('concatList', response.Rows)
            }
            commit('setPageIndex', response.PageNo + 1)
        }
        else{
            $layer.msg(response.Message);
            commit('setHasMore', false)
        }
    },
    ClearFilter({commit}){
        commit('setEmpty');
    },
    clearErrMsg({commit}){
        commit('setErrMessage','')
    },
    clearReceivingStatus({commit}){
        commit('setReceivingStatus', false)
    },
    RefreshList({commit}, isRefresh){
        commit('setRefresh', isRefresh);
    },
    SetTabIndex({commit}, index){
        commit('setTabIndex', index);
    },
    SetPageIndex({commit}, pageIndex){
        commit('setPageIndex', pageIndex);
    },
    SetSearchText({commit}, text){
        commit('setSearchText', text);
    },
    async DiscardOrder({ commit }, order){
        let response = await orderApi.DiscardOrder(order)
        if(response.Status == true){
            commit('setEmpty')
        } else {
            commit('setErrMessage', response.Message)
        }
    },
    async ReceivingOrder({ commit }, order){
        let response = await orderApi.ReceivingOrder(order)
        if(response.Status == true){
            //跳转详情页
            commit('setReceivingStatus', true)
        } else {
            commit('setErrMessage', response.Message)
        }
    }
}

const mutations = {
    setList (state, list) {
      state.List = list
    },
    concatList(state, list){
        state.List = state.List.concat(list)
    },
    setHasMore(state, hasMore) {
        state.HasMore = hasMore
    },
    setRefresh(state, isRefresh){
        state.Refresh = isRefresh
    },
    setPageIndex(state, pageIndex) {
        state.PageIndex = pageIndex
    },
    setEmpty(state) {
        state.List = []
        state.PageIndex = 1
        state.HasMore = true
    },
    setErrMessage(state, errMsg){
        state.ErrMsg = errMsg
    },
    setReceivingStatus(state, status){
        state.ReceivedStatus = status
    },
    setTabIndex(state, index){
        state.TabIndex = index
    },
    setSearchText(state, searchText){
        state.SearchText = searchText
    }
}

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/orderlist.js